module.exports = __webpack_public_path__ + "img/echope_login.5303c0bd.png";